import { Fragment } from 'react'

import { LotSymbol } from '@bonhams1793/bonhams-typescript'

import { Body, Label } from '@nx/fire/typography'

export interface FireSymbolsTableProps {
  symbols: LotSymbol[]
}

export function FireSymbolsTable({ symbols }: FireSymbolsTableProps) {
  return (
    <table>
      <tbody>
        {symbols.map(({ symbol, shortDescription, longDescription }) => (
          <Fragment key={symbol}>
            <tr>
              <Body
                $level="L"
                as="td"
                dangerouslySetInnerHTML={{
                  __html: symbol,
                }}
                css={`
                  padding-right: 10px;
                `}
              />
              <Label $level="M" as="td">
                {shortDescription}
              </Label>
            </tr>
            <tr>
              <td
                css={`
                  padding-right: 10px;
                `}
              />
              <Body
                $level="M"
                as="td"
                dangerouslySetInnerHTML={{
                  __html: longDescription,
                }}
              />
            </tr>
          </Fragment>
        ))}
      </tbody>
    </table>
  )
}
